export default __webpack_public_path__ + "static/media/artist-picture.852f1037.png";